import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { TID } from "../constants/testIds";
import { toast } from "sonner";
import Logo from "../components/Logo";

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await signup(form);
      toast.success(`Welcome, ${u.name}`);
      navigate("/map");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally { setBusy(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F172A] p-8">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <Logo size={36} textClass="text-xl" tone="light" />
        </div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Create investor account</h1>
        <p className="mt-2 text-slate-400 text-sm">Get access to full parcel legal cards, FAR calculator, and advisory booking.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-slate-400">Name</Label>
            <Input data-testid={TID.signupName} required value={form.name} onChange={set("name")} className="mt-2 bg-[#1E293B] border-[#334155] text-white h-11" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-slate-400">Email</Label>
            <Input data-testid={TID.signupEmail} required type="email" value={form.email} onChange={set("email")} className="mt-2 bg-[#1E293B] border-[#334155] text-white h-11" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-slate-400">Phone</Label>
            <Input data-testid={TID.signupPhone} value={form.phone} onChange={set("phone")} className="mt-2 bg-[#1E293B] border-[#334155] text-white h-11" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-slate-400">Password</Label>
            <Input data-testid={TID.signupPassword} required type="password" minLength={6} value={form.password} onChange={set("password")} className="mt-2 bg-[#1E293B] border-[#334155] text-white h-11" />
          </div>
          <Button data-testid={TID.signupSubmit} type="submit" disabled={busy} className="w-full rounded-full bg-[#10B981] hover:bg-[#059669] text-white h-11">
            {busy ? "Creating..." : "Create account"}
          </Button>
        </form>
        <p className="mt-8 text-center text-sm text-slate-400">
          Already have an account? <Link to="/login" className="text-[#10B981] hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
